import {
  Box,
  Button,
  ListItemText,
  MenuItem,
  Select,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import NotificationModal from "./NotificationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProfileDetails,
  setProfileState,
} from "../../redux/features/profile/profileSlice";
import {
  ArrowDownGray,
  ArrowUpWhite,
  NotificationIcon,
} from "../../assets/icons";
import Topbar from "../../components/common/Topbar";
import { colors } from "../../styles/color";
import { TabPanel } from "../../components/TabPanel";
import { YoutubeDashboardPage } from "./YouTubeDashboard";
import { MediaData } from "../../constants/menuItems";
import { setLoading } from "../../redux/features";
import { setAppState } from "../../redux/features/appStateSlice";
import { EmptyYoutubePage } from "../social/EmptyYoutubePage";
import { ToastMessage } from "../../helpers/ToastMessage";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import {
  fetchChannelSuggestionsList,
  setChannelSuggestionsState,
} from "../../redux/features/channelSuggestionList/channelSuggestionListSlice";
import { setChannelDetailsState } from "../../redux/features/channelDetails/channelDetailsSlice";
import { InstaDashboardPage } from "./InstaDashboard";
import { Helmet } from "react-helmet-async";

type props = {
  access_token?: any;
  accesstoken?: any;
};

const DashboardPage = () => {
  const { profileData } = useSelector((state: any) => state?.profile);
  const { notificationDetails } = useSelector(
    (state: any) => state.notification
  );
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state: any) => state?.dahsboard);
  const { channelDetails } = useSelector((state: any) => state?.channelDetails);
  const [currentTab, setCurrentTab] = React.useState<any>(MediaData[0]);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [selectValue, setSelectValue] = React.useState("");
  const [selectedMenu, setSelectedMenu] = React.useState("youtube");
  const navigate = useNavigate();

  const onSuccessData = async (response: props) => {
    const res = await dispatch(
      fetchChannelSuggestionsList(response?.access_token)
    );
    dispatch(setChannelSuggestionsState(res?.payload?.data));
  };

  const login = useGoogleLogin({
    onSuccess: async (res) => {
      dispatch(setLoading(true));
      await onSuccessData(res);
      dispatch(setLoading(false));
      navigate("/dashboard/add-channel");
    },
    onError: () => {
      dispatch(setLoading(false));
    },
    scope: "https://www.googleapis.com/auth/youtube.readonly",
  });

  const handleSubmit = async () => {
    if (channelDetails?.channel_name) {
      ToastMessage({
        type: "error",
        message: "You can not add more than one channel!",
      });
      navigate("/dashboard/social/youtube");
    } else {
      login();
      dispatch(setChannelDetailsState(null));
    }
  };

  useEffect(() => {
    if (dashboardData?.channels?.length)
      setSelectValue(dashboardData?.channels[0]);
  }, [dashboardData]);

  const handleChange = (newValue: string) => {
    setCurrentTab(newValue);
  };

  useEffect(() => {
    dispatch(setAppState("dashboard"));
    const getProfileData = async () => {
      dispatch(setLoading(true));
      const res = await dispatch(fetchProfileDetails());
      setTimeout(() => {
        dispatch(setProfileState(res?.payload));
        dispatch(setLoading(false));
      }, 100);
    };
    getProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Helmet>
        <title>QuickFluence Dashboard - Profile, Brand Inquiries & More</title>
        <meta
          name="description"
          content="Manage your Quickfluence profile, track brand inquiries, and update settings easily from your dashboard for smoother, smarter influencer collaborations."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/" />
        {/* Open Graph */}
        <meta
          property="og:title"
          content="Quickfluence Dashboard | Profile, Inquiries and Settings"
        />
        <meta
          property="og:description"
          content="Manage your Quickfluence profile, track brand inquiries, and update settings easily from your dashboard for smoother, smarter influencer collaborations."
        />
        <meta property="og:url" content="https://quickfluence.com/" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Quickfluence settings and profile management dashboard"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box>
        <Box
          sx={{
            "& .MuiAppBar-root": {
              height: "100%",
              padding: "13px 0 ",
              position: "sticky",
              top: 0,
            },
            "& .MuiPaper-root": {
              pr: "none",
            },
          }}
        >
          {" "}
          <Topbar>
            <Box display={"flex"} width="100%">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  "& .MuiToolbar-root": {
                    pl: { xl: 0, xs: "20px" },
                  },
                }}
              >
                <Toolbar sx={{}}>
                  <Box
                    sx={{
                      display: "flex",
                      border: "1px solid #343434",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "transparent",
                      padding: "7px",
                    }}
                  >
                    <Box
                      component="button"
                      onClick={() => {
                        setSelectedMenu("youtube");
                        setCurrentTab(MediaData[0]);
                      }}
                      sx={{
                        all: "unset",
                        color:
                          selectedMenu === "youtube" ? "white" : "#A9A9A999",
                        fontSize: { xs: "14px", sm: "16px" },

                        fontWeight: "500",
                        backgroundColor:
                          selectedMenu === "youtube"
                            ? "#1D1D1D"
                            : "transparent",
                        padding: {
                          xs: "6px 9px",
                          sm: "6px 24px",
                          md: "6px 31px",
                        },
                        cursor: "pointer",
                        userSelect: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        outline: "none",
                        transition: "all 0.2s ease",
                        borderRadius: "6px",
                        "&:active": {
                          backgroundColor:
                            selectedMenu === "youtube"
                              ? "#1D1D1D"
                              : "rgba(255, 255, 255, 0.08)",
                        },
                        "&:focus": {
                          backgroundColor:
                            selectedMenu === "youtube"
                              ? "#1D1D1D"
                              : "transparent",
                        },
                      }}
                    >
                      YouTube
                    </Box>

                    <Box
                      component="button"
                      onClick={() => {
                        setSelectedMenu("instagram");
                        setCurrentTab(MediaData[1]);
                      }}
                      sx={{
                        all: "unset",
                        color:
                          selectedMenu === "instagram" ? "white" : "#A9A9A999",
                        fontSize: { xs: "14px", sm: "16px" },
                        fontWeight: "500",
                        backgroundColor:
                          selectedMenu === "instagram"
                            ? "#1D1D1D"
                            : "transparent",
                        padding: {
                          xs: "6px 9px",
                          sm: "6px 24px",
                          md: "6px 31px",
                        },
                        cursor: "pointer",
                        userSelect: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        outline: "none",
                        transition: "all 0.2s ease",
                        borderRadius: "6px",
                        "&:active": {
                          backgroundColor:
                            selectedMenu === "instagram"
                              ? "#1D1D1D"
                              : "rgba(255, 255, 255, 0.08)",
                        },
                        "&:focus": {
                          backgroundColor:
                            selectedMenu === "instagram"
                              ? "#1D1D1D"
                              : "transparent",
                        },
                      }}
                    >
                      Instagram
                    </Box>
                  </Box>
                </Toolbar>
                <Box></Box>
              </Box>
              <Box
                display={profileData?.channel_count === 0 ? "none" : "flex"}
                sx={{
                  "& .MuiInputBase-root": {
                    border: `1px solid ${colors.dark[100]}`,
                    "& svg": {
                      width: "12px",
                    },
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "transparent",
                    },
                }}
              ></Box>
              <Box
                justifyContent={"end"}
                width={"100%"}
                flexWrap={"wrap"}
                display="flex"
              >
                <Box
                  sx={{
                    ml: "10px",
                    "& svg": {
                      height: "20px",
                      width: "20px",
                      color: colors.gray[500],
                    },
                    "& .MuiButton-root": {
                      border: `1px solid ${colors.dark[100]}`,
                      "&:hover": {
                        background: colors.dark[800],
                      },
                    },
                  }}
                >
                  <Button
                    onClick={handleClickOpen}
                    variant="text"
                    sx={{
                      background: colors.dark[800],
                      padding: {
                        xs: "25px 10px",
                        sm: "25px 18px",
                        md: "30px 20px",
                      },
                    }}
                  >
                    <Box sx={{ position: "relative" }}>
                      {notificationDetails?.unread_count !== 0 && (
                        <Box
                          sx={{
                            width: "9px",
                            height: "9px",
                            borderRadius: "15px",
                            bgcolor: "red",
                            position: "absolute",
                            mt: "-4px",
                            ml: "9px",
                            border: `2px solid ${colors.dark[600]}`,
                          }}
                        ></Box>
                      )}
                      <NotificationIcon />
                    </Box>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Topbar>
          {/* {profileData?.channel_count === "0" ? (
          <Box sx={{ padding: "0 16px", my: "16px" }}>
            <EmptyYoutubePage
              profileData={profileData}
              handleSubmit={handleSubmit}
              dashboard
            />
          </Box>
        ) : null} */}
          <Box sx={{ overflowX: "hidden" }}>
            <TabPanel currentTab={currentTab} tab="YouTube">
              <Box>
                {profileData?.channel_count === "0" ? (
                  <Box sx={{ padding: "0 16px", my: "16px" }}>
                    <EmptyYoutubePage
                      profileData={profileData}
                      handleSubmit={handleSubmit}
                      dashboard
                    />
                  </Box>
                ) : (
                  <YoutubeDashboardPage profileData={profileData} />
                )}
              </Box>
            </TabPanel>
            <TabPanel currentTab={currentTab} tab="Instagram">
              <Box sx={{ padding: "0 16px", my: "16px" }}>
                <InstaDashboardPage profileData={profileData} />
              </Box>
            </TabPanel>
          </Box>
        </Box>
        <NotificationModal
          settingNavigatePath={"/dashboard/settings"}
          open={open}
          setOpen={setOpen}
        />
      </Box>
    </>
  );
};

export default DashboardPage;
